import { useEffect, useRef } from 'react';
const safeStringify = value => {
  if (value === null) return 'null';
  if (value === undefined) return 'undefined';
  if (typeof value === 'string') return `"${value}"`;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (typeof value === 'function') return '[Function]';
  if (typeof value === 'symbol') return value.toString();
  try {
    return JSON.stringify(value, null, 0);
  } catch (error) {
    // Handle circular references or other JSON.stringify errors
    return '[Complex Object]';
  }
};
const useRenderAnalyzer = (logName, debugMode, params) => {
  const prevParamsRef = useRef();
  useEffect(() => {
    var _params$props, _params$selectors, _params$contexts;
    if (!debugMode) {
      return;
    }
    const prevParams = prevParamsRef.current;
    if (!prevParams) {
      // eslint-disable-next-line no-console
      console.debug(`[${logName}] Initial render`);
      prevParamsRef.current = params;
      return;
    }
    const changes = [];

    // Check props changes
    Object.keys((_params$props = params.props) !== null && _params$props !== void 0 ? _params$props : {}).forEach(key => {
      const currentValue = params.props[key];
      const prevValue = prevParams.props[key];
      if (currentValue !== prevValue) {
        changes.push(`props.${key}: ${safeStringify(prevValue)} → ${safeStringify(currentValue)}`);
      }
    });

    // Check selectors changes
    Object.keys((_params$selectors = params.selectors) !== null && _params$selectors !== void 0 ? _params$selectors : {}).forEach(key => {
      const currentValue = params.selectors[key];
      const prevValue = prevParams.selectors[key];
      if (currentValue !== prevValue) {
        changes.push(`selectors.${key}: ${safeStringify(prevValue)} → ${safeStringify(currentValue)}`);
      }
    });

    // Check context changes
    Object.keys((_params$contexts = params.contexts) !== null && _params$contexts !== void 0 ? _params$contexts : {}).forEach(key => {
      const currentValue = params.contexts[key];
      const prevValue = prevParams.contexts[key];
      if (currentValue !== prevValue) {
        changes.push(`context.${key}: ${safeStringify(prevValue)} → ${safeStringify(currentValue)}`);
      }
    });
    if (changes.length > 0) {
      // eslint-disable-next-line no-console
      console.debug(`[${logName}] Changes detected:`, changes);
    } else {
      // eslint-disable-next-line no-console
      console.debug(`[${logName}] No changes detected`);
    }
    prevParamsRef.current = params;
  });
};
export default useRenderAnalyzer;